import { useQuery } from "@tanstack/react-query";
import { fetchWeeklySnapshot } from "../data/api/snapshot";

export function useWeeklySnapshot() {
  return useQuery({
    queryKey: ["weeklySnapshot"],
    queryFn: fetchWeeklySnapshot,
  });
}
